import React from 'react';

import Unauthenticated from 'Components/Layouts/Unauthenticated';
import { FormHandler, Input } from 'Components/Form';
import { RedButton } from 'Components/Button';
import { Alert } from 'Components/Partials';

import Auth from 'Services/Api/Auth/Auth';

class Login extends React.Component {
    /**
     * @method render
     * @return {JSX.Element}
     */
    render() {
        const { form, handleInput, getFieldError, handleSubmit, working, alert } = this.props;

        if (process.env.MIX_COMING_SOON && process.env.MIX_APP_ENV === 'production') {
            return (
                <Unauthenticated>
                    <h2 className="text-black text-4xl font-bold text-center mb-16 font-gilroy">
                        Welcome to the Speedo S2 2023 Virtual Launch Platform.
                    </h2>

                    <p className="font-bold text-lg text-center font-gilroy mb-8">
                        Coming Soon
                    </p>
                </Unauthenticated>
            );
        }

        return (
            <Unauthenticated>
                <h2 className="text-white text-4xl font-bold text-center mb-12 font-gilroy">
                   Welcome to the Speedo S2 24 Launch Platform.
                </h2>
                <form
                    onSubmit={(e) => handleSubmit(e, Auth.login)}
                    className="w-full mb-20"
                >
                    {alert && (<Alert {...alert} />)}

                    <div className="grid sm:grid-cols-2 md:grid-cols-1 lg:grid-cols-2 gap-2 mb-8">
                        <div>
                            <Input
                                error={getFieldError('email')}
                                app={true}
                                containerClassName="mb-4 text-black"
                                textColor={"text-white"}
                                place
                                label="Email"
                                type="email"
                                placeholder="Your email address"
                                value={form.email}
                                onChange={v => handleInput('email', v)}
                            />
                        </div>

                        <div>
                            <Input
                                error={getFieldError('password')}
                                app={true}
                                containerClassName="mb-4 text-black"
                                textColor={"text-white"}
                                label="Password"
                                type="password"
                                placeholder=""
                                value={form.password}
                                onChange={v => handleInput('password', v)}
                            />
                        </div>
                    </div>

                    <div className="w-full text-center">
                        <RedButton
                            working={working}
                            text="Login"
                        />
                    </div>
                </form>

                <p className="font-gilroy mx-auto text-white font-light text-center w-3/4">
                    If you encounter any problems, need make any changes or
                    have any questions, please contact us at <a href="mailto:info@speedolaunch.com"
                                                                className="text-white font-bold">info@speedolaunch.com</a>
                </p>

                <div
                    className="text-center mb-6 text-sm underline text-app-purple-2 cursor-pointer"
                    onClick={() => handleInput('admin_login', !form?.admin_login)}
                >
                    Admin Login
                </div>
            </Unauthenticated>
        );
    }
}

export default FormHandler(Login);
